import { Play, Heart, Tv } from "lucide-react";
import { FALLBACKS, proxied } from "@/lib/api";

export default function MediaCard({ item, type, onPlay, onFav, isFav }) {
  const wide = type === "live";
  return (
    <div
      data-testid={`media-card-${item.id}`}
      onClick={() => onPlay(item)}
      className={`group relative cursor-pointer overflow-hidden rounded-lg bg-[#121217] border border-zinc-800/50 transition-transform duration-300 hover:-translate-y-1 hover:border-red-600/50 ${wide ? "aspect-video" : "aspect-[2/3]"}`}
    >
      <img
        src={proxied(item.logo) || FALLBACKS[type]}
        alt={item.name}
        loading="lazy"
        onError={(e) => { e.target.src = FALLBACKS[type]; }}
        className={`w-full h-full ${wide ? "object-contain p-4 bg-[#0a0a0f]" : "object-cover"}`}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-90" />
      {type === "live" && (
        <span className="absolute top-2 left-2 flex items-center gap-1 text-[10px] font-bold uppercase text-red-500">
          <Tv className="w-3 h-3" /> Live
        </span>
      )}
      {onFav && (
        <button
          data-testid={`fav-btn-${item.id}`}
          onClick={(e) => { e.stopPropagation(); onFav(item); }}
          className="absolute top-2 right-2 z-10 p-1.5 rounded-full bg-black/60 hover:bg-red-600 transition-colors"
        >
          <Heart className={`w-4 h-4 ${isFav ? "fill-red-500 text-red-500" : "text-white"}`} />
        </button>
      )}
      <div className="absolute bottom-0 left-0 right-0 p-2.5">
        <p className="text-xs font-semibold text-zinc-100 line-clamp-2 leading-tight" style={{ textShadow: "0 1px 3px #000" }}>
          {item.name}
        </p>
      </div>
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-red-600 text-white text-xs font-semibold">
          <Play className="w-3.5 h-3.5 fill-white" /> Play
        </div>
      </div>
    </div>
  );
}
